import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { OperatingModesActions } from './operating-modes.actions';
import { OperatingModesSelectors } from './operating-modes.selectors';

@Injectable({ providedIn: 'root' })
export class OperatingModesStore {
  state$ = this.store.select(OperatingModesSelectors.operatingModes);

  constructor(private store: Store) {}

  getOperatingModes(id: number, serial: string, deviceId: string): void {
    this.store.dispatch(
      OperatingModesActions.readOrListFeatures({
        installationId: id,
        gatewaySerial: serial,
        pairingId: deviceId,
      })
    );
  }
}
